import clsx from 'clsx';
import Image from 'next/image';
import { FC } from 'react';

import { SECTIONS_IDS } from '../../../constants/sections';
import { useLkBasePath } from '../../../hooks/use-lk-base-path';
import { ButtonLink } from '../common/ButtonLink';
import { Container } from '../common/Container';
import { CursorFollower } from '../common/CursorFollower';
import { Flex } from '../common/Flex';
import { Slider } from '../common/Slider';
import { Text } from '../common/Text';

import styles from './FirstScreen.module.scss';

export const FirstScreen: FC = () => {
  const lkBasePath = useLkBasePath();

  const slides = [
    {
      id: 'routing-engine',
      content: (
        <div className={styles.slideImage}>
          <Image
            src="/assets/routing_engine_v4.png"
            alt="routing_engine"
            width={600}
            height={315}
            layout="responsive"
            sizes="(min-width: 960px) 66vw, 100vw"
          />
        </div>
      ),
    },
    {
      id: 'dashboard',
      content: (
        <div className={styles.videoContainer}>
          <video
            src="/videos/dashboard.mp4"
            controls={false}
            autoPlay
            loop
            muted
            playsInline
            className={styles.video}
          />
        </div>
      ),
    },
  ];

  return (
    <CursorFollower>
      <Container className={styles.root} id={SECTIONS_IDS.first}>
        <Text type={'h1'} className={clsx(styles.title, styles.fadeInUp, styles.fadeInUpDelay1)}>
          One platform to accept, route <br className={styles.titleBreak} /> and settle payments worldwide
        </Text>

        <div className={styles.grid}>
          <Flex direction={'column'} className={styles.main}>
            <Text
              type={'body16'}
              color={'white50'}
              className={clsx(styles.description, styles.fadeInUp, styles.fadeInUpDelay2)}
            >
              Connect to multiple acquirers and payment methods via a single integration
              <br />
              Get clear reporting, smart routing and enterprise-grade security from day one
            </Text>

            <Flex direction={'column'} gap={4} className={clsx(styles.fadeInUp, styles.fadeInUpDelay3)}>
              <ButtonLink href={`${lkBasePath}/registration`} isOutsideLink>
                Become a merchant
              </ButtonLink>

              <ButtonLink href={`#${SECTIONS_IDS.contact}`} variant={'secondary'}>
                Request demo
              </ButtonLink>
            </Flex>
          </Flex>

          <Slider items={slides} autoplay className={clsx(styles.slider, styles.fadeInUp, styles.fadeInUpDelay4)} />
        </div>
      </Container>
    </CursorFollower>
  );
};
